/**
 * Reference visual components
 *
 * Wrapper visuals that delegate rendering to PlayVisual, FormationVisual, etc.
 * while applying display options.
 */

export { ReferenceWrapper, type ReferenceDisplayOptions } from './ReferenceWrapper'
export { PlayReferenceVisual } from './PlayReferenceVisual'
export { FormationReferenceVisual } from './FormationReferenceVisual'
export { DocumentReferenceVisual } from './DocumentReferenceVisual'
